import type { TranslationKey } from '../../core/i18n/translation';
import { APPOINTMENT_STATUS_KEYS } from './appointment-status-keys';

/** The customer document's wording, as `PortalCasePdfComposer` on the server keys it. */
const LABELS: Record<string, TranslationKey> = {
    title: 'portal.pdf.title',
    generatedOn: 'portal.pdf.generated_on',
    provenance: 'portal.pdf.provenance',
    footer: 'portal.pdf.footer',
    'note.closed': 'portal.pdf.closed_note',
    'card.stage': 'portal.stage',
    'card.nextAction': 'portal.next_action',
    'value.noStage': 'portal.no_stage',
    'value.nothingDue': 'portal.nothing_needed',
    'section.summary': 'portal.pdf.summary',
    'row.caseNumber': 'portal.case_number',
    'row.opened': 'portal.opened',
    'row.status': 'portal.pdf.status',
    'row.due': 'portal.due',
    'row.closed': 'portal.closed',
    'value.closed': 'portal.closed',
    'value.inProgress': 'portal.in_progress',
    'section.progress': 'portal.progress',
    'column.stage': 'portal.stage',
    'column.state': 'portal.pdf.status',
    'state.done': 'portal.step_done',
    'state.current': 'portal.step_current',
    'state.upcoming': 'portal.step_upcoming',
    'section.appointments': 'portal.case_appointments',
    'column.service': 'portal.pdf.column_service',
    'column.when': 'portal.pdf.column_when',
    'value.consultation': 'portal.pdf.consultation',
    'value.noTime': 'portal.appointment_no_time',
    'section.documents': 'portal.case_documents',
    'column.document': 'portal.pdf.column_document',
    'column.shared': 'portal.pdf.column_shared'
};

/**
 * Everything the customer's case document says in words, in the portal's current language.
 * `{case}` stays in the provenance line for the server to fill with the case number.
 */
export function toPortalCasePdfLabels(t: (key: TranslationKey) => string): Record<string, string> {
    const labels: Record<string, string> = {};

    for (const [key, translationKey] of Object.entries(LABELS)) {
        labels[key] = t(translationKey);
    }

    for (const [status, translationKey] of Object.entries(APPOINTMENT_STATUS_KEYS)) {
        labels[`appointmentStatus.${status}`] = t(translationKey);
    }

    return labels;
}
